<template>
  <div
    v-if="customerData"
    class="flex flex-col justify-center waiting-list-cell-renderer-customer">

    <p
      class="font-bold line-height-1"
      :class="{ 'cursor-pointer hover:text-primary': !gpMqIsMobile && hasContact }"
      @click="handleNameClick">
      <span v-if="gpMqIsMobile">#{{ turnNumberWithPrefix }}. </span>
      <span :class="{ 'text-grey italic': !contact }">{{ contactName }}</span>
    </p>

    <template v-if="gpMqIsLessOrEqualLaptopMedium">
      <div class="chips">
        <vs-chip
          v-if="gpMqIsMobile && !hideStatus"
          class="cursor-pointer"
          style="height: 26px"
          :color="getChipColor(status)"
        >
          <feather-icon
            :icon="getChipIcon(status)"
            svgClasses="h-5 w-5 mr-1" />
          <span>
            {{ getChipText(status) }}
          </span>
        </vs-chip>

        <waiting-list-cell-renderer-waiting
          :isAgGridComponent="false"
          :createdAt="createdAt"
          :customerPayload="customerData"/>
      </div>

      <waiting-list-cell-renderer-arrived
        :isAgGridComponent="false"
        :createdAt="createdAt" />
    </template>
  </div>
</template>

<script>
import waitingListStatusMixin from '@/views/modules/waiting-list/waiting-list-status.mixin';
import WaitingListCellRendererArrived from '@/views/modules/waiting-list/WaitingListCellRendererArrived.vue';
import WaitingListCellRendererWaiting from '@/views/modules/waiting-list/WaitingListCellRendererWaiting.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'WaitingListCellRendererCustomer',
  mixins: [waitingListStatusMixin],
  components: {
    WaitingListCellRendererArrived,
    WaitingListCellRendererWaiting,
  },
  props: {
    customerPayload: {
      type: [Object, null],
      default: () => null,
    },
    hideStatus: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      prefixQueuePosition: 'auth/tenantAccountSettingsWaitingListPrefixQueuePosition',
    }),
    hasContact() {
      return this.contact != null;
    },
    turnNumberWithPrefix() {
      const separator = this.prefixQueuePosition ? '-' : '';

      return `${this.prefixQueuePosition || ''}${separator}${this.turnNumber}`;
    },
    customerData() {
      if (this.customerPayload && this.customerPayload.contact) {
        return this.customerPayload;
      }

      return this.params && this.params.data
        ? this.params.data
        : null;
    },
    contact() {
      let contact = this.customerData && this.customerData.contact
        ? this.customerData.contact
        : null;

      if (!contact) {
        contact = this.customerData && this.customerData.contactCopy
          ? this.customerData.contactCopy
          : null;
      }

      return contact;
    },
    contactName() {
      return this.contact
        ? this.contact.name
        : '';
    },
    createdAt() {
      return this.customerData && this.customerData.createdAt
        ? this.customerData.createdAt
        : null;
    },
    status() {
      return this.customerData && this.customerData.status
        ? this.customerData.status
        : '';
    },
    turnNumber() {
      return this.customerData && this.customerData.turnNumber
        ? this.customerData.turnNumber
        : '';
    },
  },
  methods: {
    handleNameClick() {
      // Only open modal on desktop and if contact exists
      if (!this.gpMqIsMobile && this.hasContact) {
        this.params.context.componentParent.viewContactFromWaitingList(this.params.data);
      }
    },
  },
};
</script>

<style lang="scss">
.examplex {
  height: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    margin: 0px !important;

    &.btnx {
      margin-left: 10px !important;
      border-radius: 5px 0px 0px 5px;
    }

    &.btn-drop {
      padding-top: 2px;
      padding-bottom: 2px;
      border-radius: 0px 5px 5px 0px !important;
      border-left: 1px solid rgba(255, 255, 255,.2) !important;
      width: 41px !important;
      height: 41px !important;
    }
  }
}
</style>

<style scoped lang="scss">

.waiting-list-cell-renderer-customer {
  row-gap: 8px;
  height: 100%;

  div, span, p {
    line-height: 1;
  }

  .chips {
    display: flex;
    align-items: center;
    column-gap: 8px;
  }
}
</style>
